import React, {
  useState,
  useEffect,
  useContext,
  Fragment,
  useLayoutEffect,
} from "react";
import "./Manager.css";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Grid,
  Card,
  Chip,
  CardContent,
  LinearProgress,
  Skeleton,
} from "@mui/material";
import ProfileContainer from "../../components/ProfileContainer/ProfileContainer";
import axios from "axios";
import { useParams } from "react-router-dom";
import HelpAndSupport from "../../components/HelpAndSupport/HelpAndSupport";
import RefreshButton from "../../components/RefreshButton/Refresh";
import { AppContext } from "../../context/appContext";
import LearnerListNew from "../../components/LearnerListNew/LearnerListNew";
import FacultyListNew from "../../components/FacultyListNew/FacultyListNew";
import { Charts } from "../../components/Charts/Charts";
import { getLearners } from "../../redux/slices/learner";
import { useDispatch } from "../../redux/store";
import { getAllCoaches } from "../../redux/slices/faculty";
// import Skeleton from '@mui/lab/Skeleton';

const useStyles = makeStyles(() => ({
  divStyle: {
    display: "flex",
  },
  divStyle2: {
    display: "flex",
    justifyContent: "space-between",
  },
  divStyle3: {
    display: "flex",
    justifyContent: "space-evenly",
    // borderTop:"1px solid #d9d9d9",
  },

  divStyle4: {
    display: "flex",
  },
  labelstyle: {
    paddingLeft: "10",
  },
  field: {
    marginBottom: 20,
  },
  formStylee: {
    display: "flex",
    marginBottom: 20,
    marginTop: 10,
    justifyContent: "space-between",
  },
  boxStyle: {
    marginTop: 20,
    padding: 40,
    borderRadius: 4,
    background: "white",
    boxShadow: "0px 4px 8px rgba(140, 136, 136, 0.15)",
    "@media (max-width: 768px)": {
      padding: 20,
    },
  },
  boxStylePie: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    "@media (max-width: 900px)": {
      marginTop: 40,
    },
  },
  boxStyleLine: {
    marginTop: 20,
    padding: 40,
    borderRadius: 4,
    background: "white",
    boxShadow: "0px 4px 8px rgba(140, 136, 136, 0.15)",
    width: "100%",
  },
  cardStyle: {
    marginTop: 20,
    borderRadius: 4,
  },
  profileCard: {
    background: "#5335CA",
    boxShadow: "0px 4px 8px rgba(140, 136, 136, 0.15)",
    borderRadius: 4,
  },
  profileCardText: {
    fontSize: 16,
    color: "white",
  },
  profileCardText1: {
    color: "white",
    fontSize: 12,
  },
  text1: {
    marginTop: "50px",
    marginLeft: "25px",
  },
  text2: {
    marginTop: "30px",
  },
  text1Sub: {
    fontSize: "1.1rem",
  },
  icons: {
    height: 14,
    widht: 14,
    cursor: "pointer",
    color: "#5335CA",
  },
  button: {
    background: "#5335CA",
    "&:hover": {
      background: "#5335CA",
    },
  },
  typoText1: {
    fontFamily: "Poppins",
    fontSize: 9,
    fontWeight: 600,
  },
  qIcon: {
    height: "22.58px",
    top: "6px",
    width: "20px",
    position: "relative",
  },
  buttonn: {
    background: "#939393",
    marginRight: 10,
    "&:hover": {
      background: "#888888",
    },
  },
  form: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  label: {
    padding: "inherit",
  },
  barOne: {
    color: "#B4A6EB",
  },
  barTwo: {
    color: "#7CBD1A",
  },
  barThree: {
    color: "#BD1A41",
  },
  barFour: {
    color: "#0000FF",
  },
  barFive: {
    color: "#FACE6B",
  },
  barSix: {
    color: "#BABBBC",
  },
  barSeven: {
    color: "#3ACFF8",
  },
  capitalize: {
    textTransform: "capitalize",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  skeleton: {
    backgroundColor: "#fff",
    padding: "20px",
    boxShadow: "0px 4px 8px rgba(140, 136, 136, 0.15)",
    borderRadius: 4,
    marginTop: 20,
  },
}));

export const ManagerPage = () => {
  const dispatch = useDispatch();

  // data, setData, handleToggle, updateMessage, getUserData
  const { data, updateMessage } = useContext(AppContext);

  const classes = useStyles();
  const [allCoaches, setAllCoaches] = useState();
  const [managerData, setManagerData] = useState(null);

  let helpAndSupportMessage = `Feel free to contact us and get support from the ${
    managerData && managerData.manager.rawCompanyName
  } admin team.`;

  let { id } = useParams();
  let url = "faculty/manager/".concat(id);
  const isDesktop = window.innerWidth > 899 ? true : false;

  // To Check If The User Auth Token Is Saved or not and call other API's on component mounting
  const getUserData = async () => {
    try {
      await axios
        .get(url, {
          config: { handlerEnabled: true },
        })
        .then((response) => {
          setManagerData(response.data.data);
        });
    } catch (e) {
      if (e.response && e.response.data) {
        updateMessage(e.response.data.message);
      }
    }
  };

  // const getCoachData = async () => {
  //   try {
  //     await axios
  //       .get("faculty/coaches", {
  //         config: { handlerEnabled: true },
  //       })
  //       .then((response) => {
  //         setAllCoaches(response.data.data);
  //       });
  //   } catch (e) {
  //     if (e.response && e.response.data) {
  //       updateMessage(e.response.data.message);
  //     }
  //   }
  // };

  const getAllLearners = async () => {
    dispatch(getLearners(id));
  };

  useEffect(() => {
    getUserData();
    // getCoachData();
    dispatch(getAllCoaches());
    getAllLearners();
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(getAllCoaches());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // To Fetch All Data When User Back TYo Page After Visiting Another Tab
  const onVisibilityChange = async () => {
    let hidden;

    if (typeof document.hidden !== "undefined") {
      // Opera 12.10 and Firefox 18 and later support
      hidden = "hidden";
    } else if (typeof document.msHidden !== "undefined") {
      hidden = "msHidden";
    } else if (typeof document.webkitHidden !== "undefined") {
      hidden = "webkitHidden";
    }

    if (!document[hidden]) {
      getUserData();
      // getCoachData();
      dispatch(getAllCoaches());
      getAllLearners();
    }
  };

  useLayoutEffect(() => {
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () =>
      document.removeEventListener("visibilitychange", onVisibilityChange);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container
      component="main"
      maxWidth="xl"
      className="pd-bottom-40"
      sx={{ paddingLeft: "0", paddingRight: "0" }}
    >
      <Container maxWidth="xl">
        <Box>
          {!isDesktop && (
            <ProfileContainer userData={managerData && managerData.manager} />
          )}
        </Box>

        <Fragment>
          {data ? (
            <Box className={classes.boxStyle}>
              <div className="totalPerformance">
                <Typography variant="h5" component="h3" sx={{ flexGrow: 1 }}>
                  Total Performance
                </Typography>
                <RefreshButton />
              </div>

              <Grid container className="totalPerformanceBoxManagerPage">
                <Grid item xs={12} md={3}>
                  <Fragment>
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{ flexGrow: 1 }}
                    >
                      Learners signed up
                    </Typography>
                    <Typography component="p" variant="h4">
                      {managerData &&
                        managerData.overAllPerformance.learnersSignedUp}
                    </Typography>
                  </Fragment>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Fragment>
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{ flexGrow: 1 }}
                    >
                      Learners on programme
                    </Typography>
                    <Typography component="p" variant="h4">
                      {managerData &&
                        managerData.overAllPerformance.onProgramme}
                    </Typography>
                  </Fragment>
                </Grid>

                <Grid item xs={12} md={3}>
                  <Fragment>
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{ flexGrow: 1 }}
                    >
                      Learners on target
                    </Typography>
                    <Typography component="p" variant="h4">
                      {managerData && managerData.overAllPerformance.onTarget}
                    </Typography>
                  </Fragment>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Fragment>
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{ flexGrow: 1 }}
                    >
                      Learners below target
                    </Typography>
                    <Typography component="p" variant="h4">
                      {managerData &&
                        managerData.overAllPerformance.belowTarget}
                    </Typography>
                  </Fragment>
                </Grid>
                {/* <Grid item xs={12} md={3}>
                  <Fragment>
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{ flexGrow: 1 }}
                    >
                      Learners over target
                    </Typography>
                    <Typography component="p" variant="h4">
                      {managerData && managerData.overAllPerformance.overTarget}
                    </Typography>
                  </Fragment>
                </Grid> */}
              </Grid>
            </Box>
          ) : (
            <div className={classes.skeleton}>
              <Skeleton variant="text" height={45} />
              <div
                style={{ display: "flex", flexWrap: "wrap", margin: "0 -10px" }}
              >
                <div style={{ padding: "10px", flex: "1" }}>
                  <Skeleton variant="rect" height={150} />
                </div>
                <div style={{ padding: "10px", flex: "1" }}>
                  <Skeleton variant="rect" height={150} />
                </div>
                <div style={{ padding: "10px", flex: "1" }}>
                  <Skeleton variant="rect" height={150} />
                </div>
                <div style={{ padding: "10px", flex: "1" }}>
                  <Skeleton variant="rect" height={150} />
                </div>
              </div>
            </div>
          )}
        </Fragment>
      </Container>

      <Grid container className="mainSection">
        <Grid item xs={12} md={8.5}>
          <Container maxWidth="xl">
            <Box /*style={{ height: "100%" }}*/>
              <Grid container /*style={{ height: "100%" }}*/>
                <Grid item xs={12} sm={12} className={classes.boxStyle}>
                  <Fragment>
                    {data ? (
                      <Typography
                        className={`listHeader ${classes.divStyle}`}
                        variant="h5" component="h3"
                        component="h3"
                        sx={{ flexGrow: 1 }}
                      >
                        All Learners
                      </Typography>
                    ) : (
                      <Skeleton variant="text" height={45} />
                    )}
                  </Fragment>

                  <LearnerListNew maxHeight={400}></LearnerListNew>
                </Grid>
              </Grid>
            </Box>
            {!isDesktop && data && data._id === id && (
              <HelpAndSupport message={helpAndSupportMessage} />
            )}
          </Container>
          <Container maxWidth="xl">
            <Box style={{ height: "100%" }}>
              <Grid container style={{ height: "100%" }}>
                {/* <Grid item xs={12} className={classes.boxStyle}>
                  <Fragment>
                    {data ? (
                      <Typography
                        className={`listHeader ${classes.divStyle}`}
                        variant="h5" component="h3"
                        component="h3"
                        sx={{ flexGrow: 1 }}
                      >
                        All Coaches
                      </Typography>
                    ) : (
                      <Skeleton variant="text" height={45} />
                    )}
                  </Fragment>

                    <FacultyListNew></FacultyListNew>
                </Grid> */}
              </Grid>
            </Box>
          </Container>
        </Grid>
        <Grid item xs={12} md={3.5}>
          <Container maxWidth="xl">
            {isDesktop && (
              <ProfileContainer userData={managerData && managerData.manager} />
            )}

            {isDesktop && data && data._id === id && (
              <HelpAndSupport message={helpAndSupportMessage} />
            )}

            <Fragment>
              {data ? (
                <>
                  <Box className={classes.cardStyle}>
                    <Card>
                      <CardContent className="card-content">
                        <Typography variant="h5" component="h3" gutterBottom>
                          Learners Progress
                        </Typography>
                        {/* <Box
                        sx={{ width: "100%", marginTop: 3, marginBottom: 3 }}
                      >
                        <div className={classes.divStyle2}>
                          <Typography gutterBottom>On Programme</Typography>
                          <label>
                            {managerData && managerData.overAllProgress.onProgramme}
                            %
                          </label>
                        </div>
                        <LinearProgress
                          value={
                            managerData && managerData.overAllProgress.onProgramme
                          }
                          variant="determinate"
                          color="inherit"
                          className={classes.barOne}
                        />
                      </Box> */}
                        <Box
                          sx={{ width: "100%", marginTop: 3, marginBottom: 3 }}
                        >
                          <div className={classes.divStyle2}>
                            <Typography gutterBottom>On Target</Typography>
                            <label>
                              {managerData &&
                                managerData.overAllProgress.onTarget}
                              %
                            </label>
                          </div>
                          <LinearProgress
                            color="inherit"
                            className={classes.barTwo}
                            value={
                              managerData &&
                              managerData.overAllProgress.onTarget
                            }
                            variant="determinate"
                          />
                        </Box>
                        <Box
                          sx={{ width: "100%", marginTop: 3, marginBottom: 3 }}
                        >
                          <div className={classes.divStyle2}>
                            <Typography gutterBottom>Below Target</Typography>
                            <label>
                              {managerData &&
                                managerData.overAllProgress.belowTarget}
                              %
                            </label>
                          </div>
                          <LinearProgress
                            color="inherit"
                            className={classes.barThree}
                            value={
                              managerData &&
                              managerData.overAllProgress.belowTarget
                            }
                            variant="determinate"
                          />
                        </Box>
                        {/* <Box
                        sx={{ width: "100%", marginTop: 3, marginBottom: 3 }}
                      >
                        <div className={classes.divStyle2}>
                          <Typography gutterBottom>Over Target</Typography>
                          <label>
                            {managerData && managerData.overAllProgress.overTarget}%
                          </label>
                        </div>
                        <LinearProgress
                          value={
                            managerData && managerData.overAllProgress.overTarget
                          }
                          variant="determinate"
                          color="inherit"
                          className={classes.barFour}
                        />
                      </Box> */}
                      </CardContent>
                    </Card>
                  </Box>
                  <Box className={classes.cardStyle}>
                    <Card>
                      <CardContent className="card-content">
                        <Typography variant="h5" component="h3" gutterBottom>
                          Learners Data
                        </Typography>

                        {/* <hr
                          style={{
                            border: "0.5px solid #eee",
                            margin: "30px 0 30px 0",
                          }}
                        /> */}

                        <Box
                          sx={{
                            width: "100%",
                            marginTop: 2.5,
                            marginBottom: 2.5,
                          }}
                        >
                          <div className={classes.divStyle2}>
                            <Typography gutterBottom>
                              On Programme
                              <Chip
                                size="small"
                                sx={{
                                  marginLeft: "5px",
                                  color: "#FACE6B",
                                  border: `1px solid #FACE6B`,
                                  backgroundColor: `transparent !important`,
                                }}
                                label={
                                  managerData &&
                                  managerData.overAllProgress
                                    .onProgrammeCount &&
                                  managerData.overAllProgress.onProgrammeCount
                                }
                              />
                            </Typography>
                            <label>
                              {managerData &&
                                managerData.overAllProgress.onProgramme &&
                                managerData.overAllProgress.onProgramme}
                              %
                            </label>
                          </div>
                          <LinearProgress
                            color="inherit"
                            className={classes.barFive}
                            value={
                              managerData &&
                              managerData.overAllProgress.onProgramme &&
                              managerData.overAllProgress.onProgramme
                            }
                            variant="determinate"
                          />
                        </Box>
                        <Box
                          sx={{
                            width: "100%",
                            marginTop: 2.5,
                            marginBottom: 2.5,
                          }}
                        >
                          <div className={classes.divStyle2}>
                            <Typography gutterBottom>
                              On break
                              <Chip
                                size="small"
                                sx={{
                                  marginLeft: "5px",
                                  color: "#3ACFF8",
                                  border: `1px solid #3ACFF8`,
                                  backgroundColor: `transparent !important`,
                                }}
                                label={
                                  managerData &&
                                  managerData.overAllProgress.onBreakCount &&
                                  managerData.overAllProgress.onBreakCount
                                }
                              />
                            </Typography>
                            <label>
                              {managerData &&
                                managerData.overAllProgress.onBreak &&
                                managerData.overAllProgress.onBreak}
                              %
                            </label>
                          </div>
                          <LinearProgress
                            color="inherit"
                            className={classes.barSeven}
                            value={
                              managerData &&
                              managerData.overAllProgress.onBreak &&
                              managerData.overAllProgress.onBreak
                            }
                            variant="determinate"
                          />
                        </Box>
                        <Box
                          sx={{
                            width: "100%",
                            marginTop: 2.5,
                            marginBottom: 2.5,
                          }}
                        >
                          <div className={classes.divStyle2}>
                            <Typography gutterBottom>
                              Off Programme
                              <Chip
                                size="small"
                                sx={{
                                  marginLeft: "5px",
                                  color: "#BABBBC",
                                  border: `1px solid #BABBBC`,
                                  backgroundColor: `transparent !important`,
                                }}
                                label={
                                  managerData &&
                                  managerData.overAllProgress
                                    .offProgrammeCount &&
                                  managerData.overAllProgress.offProgrammeCount
                                }
                              />
                            </Typography>
                            <label>
                              {managerData &&
                                managerData.overAllProgress.offProgramme &&
                                managerData.overAllProgress.offProgramme}
                              %
                            </label>
                          </div>
                          <LinearProgress
                            color="inherit"
                            className={classes.barSix}
                            value={
                              managerData &&
                              managerData.overAllProgress.offProgramme &&
                              managerData.overAllProgress.offProgramme
                            }
                            variant="determinate"
                          />
                        </Box>
                        <Box
                          sx={{
                            width: "100%",
                            marginTop: 2.5,
                            marginBottom: 2.5,
                          }}
                        >
                          <div className={classes.divStyle2}>
                            <Typography gutterBottom>
                              Completed
                              <Chip
                                size="small"
                                sx={{
                                  marginLeft: "5px",
                                  color: "#7CBD1A",
                                  border: `1px solid #7CBD1A`,
                                  backgroundColor: `transparent !important`,
                                }}
                                label={
                                  managerData &&
                                  managerData.overAllProgress.completedCount &&
                                  managerData.overAllProgress.completedCount
                                }
                              />
                            </Typography>
                            <label>
                              {managerData &&
                                managerData.overAllProgress.completed &&
                                managerData.overAllProgress.completed}
                              %
                            </label>
                          </div>
                          <LinearProgress
                            color="inherit"
                            className={classes.barTwo}
                            value={
                              managerData &&
                              managerData.overAllProgress.completed &&
                              managerData.overAllProgress.completed
                            }
                            variant="determinate"
                          />
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>
                </>
              ) : (
                <div className={classes.skeleton}>
                  <Skeleton variant="text" height={50} />
                  <Skeleton variant="text" height={35} />
                  <Skeleton variant="text" height={15} />
                  <Skeleton variant="text" height={35} />
                  <Skeleton variant="text" height={15} />
                  <Skeleton variant="text" height={35} />
                  <Skeleton variant="text" height={15} />
                </div>
              )}
            </Fragment>
          </Container>
        </Grid>
      </Grid>
    </Container>
  );
};
